import styled from "styled-components";
import { useCallback, useEffect, useRef, useState } from "react";

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  stickyStyle?: React.CSSProperties;
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
  zIndex?: number;
  bgColor?: string;
  stickyBgColor?: string;
  scrollItem?: HTMLElement;
  className?: string;
};

const StyledAppSticky = styled.div<Props>`
  position: sticky;
  top: ${({ top }) => top || 0}px;
  bottom: ${({ bottom }) => bottom || 0}px;
  left: ${({ left }) => left || 0}px;
  right: ${({ right }) => right || 0}px;
  z-index: ${({ zIndex }) => zIndex || 1000};
  background-color: ${({ bgColor }) => bgColor || "transparent"};
  transition: background-color 0.3s ease;
`;

const ComponentName = "AppSticky";

export default function AppSticky(props: Props) {
  const { children, scrollItem, style, stickyStyle, className } = props;
  const ref = useRef<HTMLDivElement>(null);
  const [isSticky, setIsSticky] = useState(false);

  const listener = useCallback(
    (e: any) => {
      if (e.target.scrollTop > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    },
    [props.bgColor, props.stickyBgColor],
  );

  useEffect(() => {
    if (!scrollItem) return;

    scrollItem.addEventListener("scroll", listener);
    scrollItem.addEventListener("resize", listener);

    return () => {
      scrollItem.removeEventListener("scroll", listener);
      scrollItem.removeEventListener("resize", listener);
    };
  }, [scrollItem, props.bgColor, props.stickyBgColor, listener]);

  if (!scrollItem) return children;

  return (
    <StyledAppSticky
      ref={ref}
      {...props}
      style={{ ...style, ...(isSticky ? stickyStyle : {}) }}
      className={`${ComponentName} ${isSticky ? "sticky" : ""} ${className || ""}`}
      bgColor={isSticky ? props.stickyBgColor : props.bgColor}
    >
      {children}
    </StyledAppSticky>
  );
}
